<div>
	<div class="title" (click)="toggleCollapsed()">
		<span>{{ title }}</span>
		<i nz-icon [nzType]="isCollapsed ? 'up' : 'down'"></i>
	</div>
	@if (!isCollapsed) {
		<div class="content" [class.overflow]="overflow">
			<ng-content></ng-content>
		</div>
	}
</div>
